module.exports = __webpack_public_path__ + "static/media/arrow-right.1017ec87.svg";